<template>
  <a-card :bordered='false' style="width: 100%" v-show='checkResult'>
    <div v-if="this.extractHtml!=='' && !stampShowed" >
      <SignFileShow :sectionId='sectionId' :type='pdfParams.type'></SignFileShow>
    </div>
    <div v-show="!stampShowed">
      <div v-show="!disabled" id="pdfCentent">
        <h1 style="text-align: center">F值随机抽取表</h1>
        <span style="font-size: 16px; text-align: center; display: block">第{{ this.extractTimes }}次抽取</span>
        <a-spin tip="加载中......" :spinning="false">
          <table>
            <tr>
              <th :colspan="((topValue-bottomValue) * 2 + 1) + 1" >F的取值区间</th>
            </tr>
            <tr>
              <th>抽取范围</th>
              <td v-for="(item, i) in ((topValue-bottomValue) * 2 + 1)">
                {{ bottomValue + i * 0.5 }}%
              </td>
            </tr>
            <tr>
              <th>对应球号</th>
              <td v-for="(item, i) in ((topValue-bottomValue) * 2 + 1)">
                <a-input-number
                  v-model='ball[i]'
                  style="margin: -5px 0;width: 40px;"
                  @change="e => handleBallChange(e, i)"
                />
              </td>
            </tr>
            <tr>
              <th>抽中球号</th>
              <td :colspan="((topValue-bottomValue) * 2 + 1)">
                <a-input-number
                  v-model='extractBall'
                  style="margin: -5px 0"
                  @change="e => handleBall(e, index)"
                />
              </td>
            </tr>
            <tr>
              <th>对应数值</th>
              <td :colspan="((topValue-bottomValue) * 2 + 1)">
                {{ ballValue }}%
              </td>
            </tr>
            <tr>
              <th :colspan="((topValue-bottomValue) * 2 + 1) + 1">
                F值抽取结果 F值=
                <span>{{ ballValue }}</span>%
              </th>
            </tr>
            <tr>
              <th>招标人</th>
              <td :colspan="((topValue-bottomValue) * 2 + 1)"></td>
            </tr>
            <tr>
              <th>招标代理</th>
              <td :colspan="((topValue-bottomValue) * 2 + 1)"></td>
            </tr>
          </table>
        </a-spin>
      </div>
<!--      <div v-if="disabled" v-html="extractHtml" id="printContent"></div>-->
    </div>
    <h2 align="center" style="margin-top: 10px">
      <span v-show="disabled && !stampShowed">
        <a-button type="primary" style="margin-left: 10px;margin-right: 10px;" @click="reEdit()">重新抽取</a-button>
      </span>
      <span v-show="!stampShowed && !disabled && this.extractTimes != 1">
        <a-button type="primary" style="margin-right: 10px" @click="cancle()">取消</a-button>
      </span>
<!--      <a-button v-show="!stampShowed" type="primary" style="margin-left: 10px" :disabled="disabled" @click="signExtractF">签章</a-button>-->
<!--      <a-button  v-show='!stampShowed && disabled' type='primary' @click="signShow" style="margin-left: 10px">签章文件查看</a-button>-->
<!--      <a-button v-show="stampShowed" htmlType="button" @click='reWrite' type="primary" style="margin-right: 10px">重新编辑</a-button>-->
<!--      <a-button v-show="stampShowed" htmlType="button" @click='getSignedPdf' type="primary" style="margin-right: 10px">获取签章文件</a-button>-->
      <SignatureButton
        v-show="!stampShowed"
        ref="SignatureButton"
        :pdf-params="pdfParams"
        :stampShowed="stampShowed"
        :disabled="disabled"
        @sign="sign"
        @signShow="signShow"
      ></SignatureButton>
      <a-button v-show="!stampShowed" type="primary" style="margin-left: 10px" :disabled="disabled" @click="okHandle()">提交</a-button>
<!--      <a-button type="primary" :disabled="!disabled" style="margin-left: 10px" v-print="'#printContent'">打印</a-button>-->
    </h2>
<!--    <div>-->
<!--      <iframe v-show="stampShowed" ref='signIframe' frameBorder="no" :src="pdfParams.signedPdfUrl" width='100%' height="900" style='border-bottom:1px solid #3D3D3D;'></iframe>-->
<!--    </div>-->
<!--    <stamp-->
<!--      :is-stamp="isStamp"-->
<!--      ref="stamp"-->
<!--      :pdf-params="pdfParams"-->
<!--      @checkStampForm="checkStampForm"-->
<!--      @changeIsStamp="changeIsStamp"-->
<!--    ></stamp>-->
    <SignatureComponent
      v-show="stampShowed"
      ref="stamp"
      :pdf-params="pdfParams"
      @checkStampForm="checkStampForm"
      @changeIsStamp="changeIsStamp"
    >
      <template v-slot:footer>
        <a-button type="primary" :disabled="disabled" @click="okHandle()">提交</a-button>
      </template>
    </SignatureComponent>

    <SignFileShow-modal ref="modalForm"></SignFileShow-modal>
  </a-card>
</template>

<script>
import { postAction, getAction } from '@api/manage'
import { StatusMixin } from '@/mixins/StatusMixin'
import stamp from '@/components/Stamp'
import WorkChangeStamp from '@/components/WorkChangeStamp'
import SignatureComponent from '@/components/SignatureComponent'
import SignatureButton from '@/components/SignatureButton'
import numeral from 'numeral'
import { toHtml }  from '@/utils/htmlUtil'
import SignFileShowModal from '../modules/SignFileShowModal'
import SignFileShow from "@views/bobidopen/modules/SignFileShow.vue";
export default {
  name: 'extractFCustom',
  components: {SignFileShow, WorkChangeStamp, stamp ,SignatureComponent,SignatureButton,SignFileShowModal},
  mixins: [StatusMixin],
  data() {
    return {
      extractHtml:'',
      bidProjectId: '',
      sectionId: '',
      extractTimes: 0,
      disabled: true,
      topValue: 0,
      bottomValue: 0,
      ball: [],
      firstBall: [],
      secondBall: [],
      extractBall: null,
      extractFirstBall: null,
      extractSecondBall: null,
      ballValue: null,
      firstValue: null,
      secondValue: null,
      //以下签章需要-----------------------
      isStamp: true,
      pdfParams: {
        pageId:"",
        signedPdfUrl: "",
        bidProjectId: '1',
        sectionId: '1',
        type: 'extractF',
        typeZh: 'F值抽取签章',
        htmlTitle: 'F值抽取签章',
        fp: '4',
        signType:'1'//1:统一CA，2：工改签章
      },
      stampShowed: false,
      // disableMixinCreated: true,
    }
  },
  props: ['checkId'],
  created() {},
  methods: {
    setBidProjectId(id, sectionId) {
      //1.根据招标编号ID获取招标项目信息和项目信息
      this.sectionId = sectionId
      this.bidProjectId = id
      this.pdfParams.bidProjectId = id
      this.pdfParams.sectionId = sectionId
      //设置本页面标识，用于redis key记录当前页面签章信息
      this.pdfParams.pageId = this.sectionId + "_extractF_" + new Date().getTime();
      this.queryStatus()
      this.getExtractResult()
    },
    getExtractResult() {
      getAction('/ebid-ce/boOpenExtractfConfig/getExtractResult/' + this.sectionId, {}).then((res) => {
        if (res.success) {
          if(res.result.length > 0) {
            this.extractHtml = res.result[0].resultHtml;
            this.disabled = true;
            this.extractTimes = res.result.length;
          } else {
            this.getTopAndBottom()
            this.disabled = false;
            this.extractTimes = 1;
          }
        }else {
          this.$message.warning(res.message)
        }
      })
    },
    getTopAndBottom() {
      getAction('/ebid-ce/boOpenExtractfConfig/getTopAndBottom/' + this.sectionId, {}).then((res) => {
        if (res.success) {
          this.topValue = res.result[1]
          this.bottomValue = res.result[0]
        }else {
          // this.$message.warning(res.message)
        }
      })
    },
    handleBallChange(v , index) {
      for (let i = 0; i < this.ball.length; i++) {
        if( v == this.ball[i] && index != i) {
          this.ball[index] = null
          // this.$message.warning("对应代表球号重复，请重新填写！")
          return
        }
      }
      this.ball[index] = v;
      this.extractBall = null;
      this.ballValue = null;
    },
    handleFirstBallChange(v , index) {
      for (let i = 0; i < this.firstBall.length; i++) {
        if( v == this.firstBall[i] && index != i) {
          this.firstBall[index] = null
          // this.$message.warning("对应代表球号重复，请重新填写！")
          return
        }
      }
      this.firstBall[index] = v;
    },
    handleSecondBallChange(v , index) {
      for (let i = 0; i < this.secondBall.length; i++) {
        if( v == this.secondBall[i] && index != i) {
          this.secondBall[index] = null
          // this.$message.warning("对应代表球号重复，请重新填写！")
          return
        }
      }
      this.secondBall[index] = v;
    },
    handleBall(v) {
      for (let i = 0; i < this.ball.length; i++) {
        if(this.ball[i] == v) {
          this.extractBall = v;
          this.ballValue = i * 0.5 + this.bottomValue ;
          return
        }
      }
      this.extractBall = null;
      this.ballValue = null;
      // this.$message.warning("对应代表球号不存在，请重新填写！")
    },
    handleFirstBall(v) {
      for (let i = 0; i < this.firstBall.length; i++) {
        if(this.firstBall[i] == v) {
          this.extractFirstBall = v;
          this.firstValue = i;
          return
        }
      }
      this.extractFirstBall = null;
      this.firstValue = null;
      // this.$message.warning("对应代表球号不存在，请重新填写！")
    },
    handleSecondBall(v) {
      for (let i = 0; i < this.secondBall.length; i++) {
        if(this.secondBall[i] == v) {
          this.extractSecondBall = v;
          this.secondValue = i;
          return
        }
      }
      this.extractSecondBall = null;
      this.secondValue = null;
      // this.$message.warning("对应代表球号不存在，请重新填写！")
    },
    reEdit() {
      this.disabled = false
      this.extractTimes += 1
      this.extractHtml='';
      this.getTopAndBottom()
    },
    cancle() {
      this.disabled = true
      this.extractTimes += -1
    },
    okHandle() {
      if (this.$refs.stamp.getPdfUrl() == null) {
        this.$message.info('请先签章')
        return
      }

      let that = this;
      let params ={};
      params.sectionId = this.sectionId;
      params.bidProjectId = this.bidProjectId;
      params.finteger = JSON.stringify(this.ball);
      params.fintegerBall = this.extractBall;
      params.fintegerValue = this.ballValue;
      params.fvalue = this.ballValue;
      params.extractTimes = this.extractTimes;
      params.resultHtml =  toHtml('pdfCentent')
      params.pdfUrl = that.$refs.stamp.getPdfUrl()
      params.type = that.pdfParams.type
      params.typeZh = that.pdfParams.typeZh
      postAction('/ebid-ce/boOpenExtractfConfig/extractResult/' + this.bidProjectId + "/" + this.sectionId, params).then((res) => {
        if (res.success) {
          that.extractHtml = params.resultHtml;
          that.disabled = true;
          that.$message.success(res.result)
        } else {
          that.$message.warning(res.message)
        }
      })
    },
    /**
     * 签章入围企业
     */
    sign(type) {
      this.pdfParams.signType = type;
      if( this.ball.length != ((this.topValue - this.bottomValue)*2+1) ) {
        this.$message.warning("对应代表球号存在空值，请重新填写！")
        return
      }
      for (let i = 0; i < this.ball.length; i++) {
        if( this.ball[i] == "" || this.ball[i] == null) {
          this.$message.warning("对应代表球号存在空值，请重新填写！")
          return
        }
      }
      for (let i = 0; i < this.firstBall.length; i++) {
        if( this.firstBall[i] == "" || this.firstBall[i] == null) {
          this.$message.warning("对应代表球号存在空值，请重新填写！")
          return
        }
      }
      if( this.extractBall == null ) {
        this.$message.warning("抽取球号为空，请重新填写！")
        return
      }
      let that = this
      this.$confirm({
        title: '提示',
        content: '您确定要进行签章操作吗？',
        onOk() {

          that.$refs.stamp.checkStamp()
        },
        onCancel(){
          that.pdfParams.pageId="";
          that.pdfParams.signedPdfUrl="";
          that.stampShowed = false;
          that.$refs.stamp.pdfUrl=null;
        },
      })
    },
    //签章文件查看
    signShow() {
      this.$refs.modalForm.show(this.sectionId,this.pdfParams.type);
    },
    //重新编辑
    reWrite(){
      this.pdfParams.pageId="";
      this.pdfParams.signedPdfUrl="";
      this.stampShowed = false;
      this.$refs.stamp.pdfUrl=null;
    },
    // getSignedPdf(){
    //   let that = this;
    //   that.$confirm({
    //     title: '确认信息',
    //     content: '请确认是否已经完成签章，未完成则先完成签章，完成则点击确认获取签章文件！',
    //     onOk() {
    //       that.$refs.stamp.getPdfUrl();
    //     },
    //     onCancel(){
    //     },
    //   })
    // },
    checkStampForm(callback) {
      callback(true)
    },
    changeIsStamp(val) {
      this.stampShowed = val
    },
  },
}
</script>

<style scoped>
@import '~@assets/less/common.less';

table,
table tr th,
table tr td {
  border: 1px solid #ccc;
  text-align: center;
}

th {
  padding-left: 10px;
  font-weight: normal;
  padding-top: 10px;
  padding-bottom: 10px;
}

table {
  width: 100%;
  border-collapse: collapse;
}

input {
  text-align: center;
  border-bottom: 1px solid #000;
  border-top: 0px;
  border-left: 0px;
  border-right: 0px;
  outline: none;
}

>>> .ant-input-number-input {
  text-align: center !important;
  padding: 0 !important;
}

>>> .ant-input-number-handler-wrap {
  display: none;
}
</style>